<template>
    <div class="page-deliver-home-add">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺設置</div>
            <div class="breadcrumb-item">送貨上門設定 新增</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="30" push="5">
                        <Form :label-width="100">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>區域</span>
                                        </div>
                                        <Input v-model="form.addres"/>
                                    </FormItem>
                                </Col>
                            </Row>
							
							<!-- <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <span>增加時間段</span>
                                        </div>
										<Select placeholder="請選擇" not-found-text="無匹配數據"
                                            label-in-value
                                            v-model="boxSelected"
                                            @on-change="handleShopSelectChange"
											>
											<Option value="12:00 -15:00">12:00 -15:00</Option>
											<Option value="15:00 -18:00">15:00 -18:00</Option>
											<Option value="18:00 -21:00">18:00 -21:00</Option>
											<Option value="21:00 -24:00">21:00 -24:00</Option>
										</Select>
										<TimePicker class="no-suffix" type="time" size="small" placeholder="起始日期" v-model="form.start_time" value-format="hh:mm:ss"></TimePicker>
										<TimePicker class="no-suffix" type="time" size="small" placeholder="結束日期" v-model="form.end_time" value-format="hh:mm:ss"></TimePicker>
                                    </FormItem>
                                </Col>
                            </Row> -->

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>時間段</span>
                                        </div>
										<!-- <div class="input-value">
										<span v-for="(m, n) in form.timedata" style="padding: 0 5px;margin: 0 5px;font-size: 18px;position: relative;">
											{{m}}
										<img style="display: inline-block;width:18px;height: 18px;top: 2px;position: relative;" src="../../../assets/images/del.png" @click="unSelect(m)"></img>
										</span>
										</div> -->
										<Input v-model="form.timedata"/>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>減免金額</span>
                                        </div>
                                        <Input v-model="form.discount"/>
                                    </FormItem>
                                </Col>
                            </Row>
							
							<Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <span>區域負責人電話</span>
                                        </div>
                                        <Input v-model="form.phone"/>
                                    </FormItem>
                                </Col>
                            </Row>
							
							<Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <span>描述</span>
                                        </div>
                                        <Input v-model="form.description"/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">修改</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                    <!-- <Button type="error" :loading="true" class="loading-btn">
                                         <span>Loading...</span>
                                     </Button>-->
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageParam: {},
                isSubmiting: false,
				boxSelected: 0,
                form: {
                    addres: '',
                    description: '',
                    discount: '',
					timedata: '',
					id: '',
                    phone: '',
					remarks: '',
                }
            };
        },
        mounted()
        {
            // this.pageParam = this.$route.query;
            // this.getDetail();
        },
        methods: {
			unSelect(id) 
			{
				for (let i = 0; i < this.form.timedata.length; i++) {
				    if (id == this.form.timedata[i]) {
						this.form.timedata.splice(i, 1);
				    }
				}
			},
            handleShopSelectChange(e)
            {
                if (e) {
                    if(e.value != 0) {
						let isExist = false;
						for (let i = 0; i < this.form.timedata.length; i++) {
						    if (e.label == this.form.timedata[i]) {
						        isExist = true;
						        break;
						    }
						}
						if (!isExist) {
						    this.form.timedata.push(e.label);
						} else {
						    this.$Utils.showTipInfo('已存在該時間段');
						}
						this.boxSelected = 0;
					}
                }
            },
            handleBack()
            {
                this.$router.go(-1);
            },

            handleCheckForm()
            {
                let form = this.form;

                if (form.addres === '')
                {
                    this.$Utils.showTipInfo('請輸入區域');
                    return;
                } 
				else if (form.timedata === '')
                {
                    this.$Utils.showTipInfo('請輸入時間段');
                    return;
                } 
				else if (form.discount === '')
                {
                    this.$Utils.showTipInfo('請輸入減免金額');
                    return;
                } 
                this.handleSubmit();

            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.deliverHomeAdd,
                    method: 'post',
                    data: {
                        addres: form.addres,
                        phone: form.phone,
                        description: form.description,
                        discount: form.discount,
						timedata: form.timedata
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 200)
                    {
                        this.$Utils.showSuccess(res.msg);
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "DeliverHomeAdd.scss";
</style>